import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useEmailMarketingUnsubscribePageQuery } from "__generated__/graphqlUnauthenticated";
import { getPrimaryEmail } from "./getPrimaryEmail";
import { EmailMarketingUnsubscribePageUI } from "./EmailMarketingUnsubscribePageUI";

export const EmailMarketingUnsubscribePage: React.FC = () => {
  const { t: translate } = useTranslation("email_marketing");
  const { token } = useParams<{ token: string }>();
  const emsUserToken = token || "";
  const { data, loading } = useEmailMarketingUnsubscribePageQuery({
    variables: {
      emsUserToken,
    },
    skip: !token,
  });
  const primaryEmail = getPrimaryEmail(
    data?.emailMarketingCampaignRecipientVariables?.entries || [],
  );
  const unsubscribeDomain =
    data?.emailMarketingCampaignRecipientUnsubscribeData?.unsubscribeDomain ||
    translate("email_unsubscribe.all_communications");
  return (
    <EmailMarketingUnsubscribePageUI
      loading={loading}
      primaryEmail={primaryEmail}
      emsUserToken={emsUserToken}
      unsubscribeDomain={unsubscribeDomain}
    />
  );
};
